//all we need for the purposes of mapping is the locationName and the rmoPropertyId
export class RMO_Property {
	propertyID: any;
	name: string;
	locationId : number;
}

export class RMO_PropertyMapping {
	id: number;
	clientLocationId: number;
	rmO_PropertyId: number;
	corpId: string;
	rmO_LocationId : number;
}

export class RMO_ClientMapping {
    id: number;
    clientId: number;
    corpId: string;
}

export class RMO_ClientMeta {
	clientConnectedDate: Date;
	dateLastTransferred: Date;
}